<template>
  <b-modal
    id="exportoffice"
    title="Export to Word/Excel/PDF"
    size="md"
    ok-only
    ok-title="Close"
  >
    <div v-if="!this.isTrial">
      <p>
        <b-form-radio-group id="export-type" name="export-type" v-model="type">
          <b-form-radio value="Word">Word</b-form-radio>
          <b-form-radio value="Excel">Excel</b-form-radio>
          <b-form-radio value="PDF">PDF</b-form-radio>
        </b-form-radio-group>
      </p>
      <p>
        The {{ type }} export will contain
        <span v-if="type === 'PDF' && numResults < numFound"
          >{{ numResults }} of
        </span>
        <span v-else>all </span>
        {{ numFound }} results of your last search for:
        <b v-if="terms">{{ terms }}</b>
        <b v-else>*</b>
      </p>

      <div v-if="activefilters && activefilters.filters" class="mb-3">
        <div class="mb-3">
          <span class="text-muted">{{ $t("filters.active_filters") }}: </span>

          <b-badge
            v-for="filter in activefilters.filters"
            :key="'exp' + filter.value"
            variant="light"
            size="sm"
            class="mr-1 mb-1"
          >
            <b v-if="filter.componentName == 'Budget_Total'"
              >{{ $t("scifund.labels." + filter.componentName) }}:
              {{ formatBudget(filter.valueLabel) }}</b
            >

            <b
              v-else-if="
                filter.componentName == 'Publication_Date' ||
                  filter.componentName == 'Deadlines'
              "
              >{{ $t("scifund.labels." + filter.componentName) }}:
              {{ formatDate(filter.valueLabel) }}</b
            >

            <b v-else-if="filter.componentName == 'Opening_Dates'"
              >{{ $t("scifund.labels." + filter.componentName) }}:
              {{ formatDate(filter.valueLabel) }}</b
            >

            <b v-else
              >{{ $t("scifund.labels." + filter.componentName) }}:
              {{ filter.valueLabel | truncate(50, "...") }}</b
            >
          </b-badge>
        </div>
      </div>

      <div class="mt-2" v-if="type === 'PDF'">
        <vue-slider
          v-model="numResults"
          :marks="marks"
          class="sl mb-5"
          :contained="true"
          v-bind="options"
        ></vue-slider>
      </div>

      <b-alert
        show
        variant="warning"
        v-if="type !== 'PDF' && numFound >= exportWarnLimit"
        class="mt-3"
        >Download might take some time.</b-alert
      >
      <b-alert
        show
        variant="warning"
        v-else-if="type === 'PDF' && numResults >= exportWarnLimit"
        class="mt-3"
        >Download might take some time.</b-alert
      >
      <b-alert show variant="danger" v-if="note" class="mt-3">{{
        note
      }}</b-alert>
      <b-spinner
        style="width: 3rem; height: 3rem;"
        variant="secondary"
        v-if="this.modalLoading"
      ></b-spinner>
      <b-button
        variant="dark"
        size="md"
        v-on:click.prevent="generateReport()"
        class="mt-2"
        v-else
        >Download</b-button
      >
    </div>
    <div v-else>
      <p>
        <img
          src="https://www.sci-fund.ai/wp-content/uploads/2021/05/sci-fund-pdf-export.png"
          width="300"
        />
      </p>
      <p>
        Export to Word/Excel/PDF is not available in the <b>TRIAL</b> version.
        Want to
        <a href="https://sci-fund.ai/plans-and-prices" target="_blank"
          >upgrade your account</a
        >?
      </p>
    </div>

    <b-alert v-if="modalError" variant="danger" show class="mt-3">{{
      modalError
    }}</b-alert>
  </b-modal>
</template>

<script>
export default {
  name: "ExportToOfficeOrPDF",
  data() {
    return {
      note: "",
      numResults: 100,
      options: {
        min: 10,
        max: 500,
        interval: 10,
      },
      marks: [10, 30, 50, 100, 200, 300, 400, 500],
      type: "PDF",
    };
  },
  filters: {
    truncate: function(text, length, suffix) {
      if (text && text.length > length)
        return text.substring(0, length) + suffix;
      else return text;
    },
  },
  computed: {
    downloadurl() {
      if (
        this.$store.state.response &&
        this.$store.state.response.base_urls &&
        this.$store.state.response.base_urls &&
        this.$store.state.response.base_urls.search_with_current_state &&
        this.$store.state.response.context &&
        this.$store.state.response.context.originalSearchTerms
      ) {
        return (
          this.$store.state.response.base_urls.search_with_current_state
            .sem_url +
          "&q=" +
          encodeURI(this.$store.state.response.context.originalSearchTerms)
        );
      }
      return null;
    },
    exportFieldOptions() {
      if (this.$store.state.exportFieldOptions) {
        return this.$store.state.exportFieldOptions;
      }
      return [];
    },
    exportWarnLimit() {
      if (this.$store.state.exportWarnLimit) {
        return this.$store.state.exportWarnLimit;
      }
      return 1000000;
    },
    isTrial() {
      if (this.$store.state) {
        return this.$store.state.isTrial;
      }
      return false;
    },
    activefilters() {
      if (
        this.$store.state.response &&
        this.$store.state.response.active_filters
      ) {
        return this.$store.state.response.active_filters;
      }
      return null;
    },
    numFound() {
      return this.$store.state.response && this.$store.state.response.response
        ? this.$store.state.response.response.numFound
        : 0;
    },
    terms() {
      if (
        this.$store.state &&
        this.$store.state.response &&
        this.$store.state.response.context.originalSearchTerms
      ) {
        return this.$store.state.response.context.originalSearchTerms;
      } else {
        return "";
      }
    },
    modalError() {
      if (this.$store.state.modalError) {
        return this.$store.state.modalError;
      } else {
        return "";
      }
    },
    modalLoading() {
      if (this.$store.state.modalLoading) {
        return this.$store.state.modalLoading;
      } else {
        return "";
      }
    },
  },
  methods: {
    generateReport() {
      if (this.downloadurl) {
        if (this.type === "PDF") {
          this.$store.dispatch("exportToPDF", {
            searchURL: this.downloadurl,
            numResults: this.numResults,
          });
        } else if (this.type == "Word") {
          this.$store.dispatch("exportToWord", {
            searchURL: this.downloadurl,
          });
        } else {
          this.$store.dispatch("exportToExcel", {
            searchURL: this.downloadurl,
          });
        }
      } else {
        this.note =
          "Download is not available. In case the problem persists please contact support.";
      }
    },
    formatDate: function(v) {
      return v
        .replaceAll("T000000Z", "")
        .replaceAll("T000000.000Z", "")
        .replaceAll("T00:00:00Z", "")
        .replaceAll("T00:00:00.000Z", "");
    },
    formatBudget: function(v) {
      return v.replaceAll(/(\d+)(0{6})\b/g, "$1M");
    },
  },
};
</script>
<style scoped></style>
